exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headStyle {\n  text-align: center;\n  font-size: 22px;\n  font-weight: 500;\n  margin-top: 10px;\n  color: #6b6a6a; }\n\n.InputStyle {\n  padding: 10px;\n  background-color: #efefef;\n  margin-bottom: 10px; }\n  .InputStyle .selecStyle {\n    display: inherit;\n    width: 56%;\n    padding-left: 16px;\n    margin-left: 50px;\n    border-radius: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/location/live-history/live-history.component.scss
// module id = ../../../../../src/app/location/live-history/live-history.component.scss
// module chunks = main